import { Route, Routes } from "react-router-dom";
import NewNavbar from "../components/NewNavbar";
import Home from "../components/Home";
import Historia from "../components/Historia";
import Editorial from "../components/Editorial";
import Articulos from "../components/Articulos";
import Entrevistas from "../components/Entrevistas";
import Legal from "../components/Legal";
import Perfiles from "../components/Perfiles";
import Asociados from "../components/Asociados";
import HistoriaEmpresarial from "../components/HistoriaEmpresarial";
import NewFooter from "../components/Footer";
import Anuncia from "../components/Anuncia";
import InformeEconomico from "../components/InformeEconomico";
import App from "../App";
import Categorias from "../components/Categorias";
import Noticias from "../components/Noticias";
import News from "../components/News";

const Views = () => {
    return (
        <>
            <NewNavbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/nosotros" element={<Historia />} />
                <Route path="/editorial" element={<Editorial />} />
                <Route path="/perfiles" element={<Perfiles />} />
                <Route path="/asociados" element={<Asociados />} />
                <Route path="/anuncia" element={<Anuncia />} />
                <Route path="/informe" element={<InformeEconomico />} />
                {/* <Route path="/categorias" element={<Categorias />} /> */}
                <Route path="/categorias/:id" element={<Categorias />} />
                <Route path="/categorias" element={<Noticias />} />
                <Route path="/noticias/:id" element={<News />} />

            </Routes>
            <NewFooter />
        </>
    );
};

export default Views;